import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { useStore } from 'models/stores';

import JobHeader from './JobHeader';

function Job({ data }) {
  const { uiStore } = useStore();

  const languageData = data.languages.find((l) => l.language === uiStore.language);
  const shortDescription = languageData.shortDescriptionHtml || data.shortDescription;

  return (
    <JobEntryContainer onMouseEnter={data.load}>
      <JobEntry>
        <JobHeader job={data} langData={languageData} />
        <JobShortDescription dangerouslySetInnerHTML={{ __html: shortDescription }} />
      </JobEntry>
    </JobEntryContainer>
  );
}

export default observer(Job);

const JobEntryContainer = styled.div`
  overflow-wrap: break-word;
  box-sizing: border-box;
  position: relative;
  background-color: #f6f6f6;
  color: ${(p) => p.theme.textColor};
  width: 100%;
  display: flex;
  align-items: center;
  @media (max-width: 1080px) {
    padding: 0px 20px;
  }

  :hover {
    cursor: pointer;
    background-color: #ffffff;

    > div {
      > h2 {
        color: ${(p) => p.theme.headingHoverColor};
        font-family: ${(p) => p.theme.secondFont};
      }
    }
  }
`;

const JobEntry = styled.div`
  padding: 40px 0;
  margin: 0 auto;
  width: 100%;
  max-width: 980px;
  > * {
    max-width: 580px;
  }

  > h2 {
    font-family: ${(p) => p.theme.secondFont};
    font-size: 26px;
    color: ${(p) => p.theme.headingColor};
    font-weight: bold;
    margin: 0 0 0.2em 0;
    word-break: break-word;
  }
`;

const JobShortDescription = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 20px;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  p {
    margin: 0;
    padding: 0;
  }
  p:empty {
    padding: 8px 0;
  }
`;
